import React from 'react';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import Grid from "@mui/material/Grid";

function GalleryComponent(props: { images: any[]; }) {
    return (
        <section id="section1" className="section section-gallery">

            <Container maxWidth="lg">

                <h1>Des idées pour un cadeau de naissance original</h1>
                <p>Des cadeaux faits main et personnalisables</p>

                <Grid container spacing={2}>
                    {props.images.map((item, index: number) => (
                    <Grid item xs={6} sm={3} key={index}>
                        <img
                            src={`${item.img}?w=250&h=250&fit=crop&auto=format`}
                            srcSet={`${item.img}?w=250&h=250&fit=crop&auto=format&dpr=2 2x`}
                            alt={item.title}
                            loading="lazy"
                            width="100%"
                        />
                    </Grid>
                    ))}
                </Grid>

                <Button size="large" variant="contained" color="secondary" href="https://www.facebook.com/TendreConception/photos/" target="_blank">Voir plus</Button>

            </Container>
        </section>
    );
}

export default GalleryComponent;
